/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Password_DescriptionInputs */

const en_auth_reset_password_description = /** @type {(inputs: Auth_Reset_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a new password for your account`)
};

const es_auth_reset_password_description = /** @type {(inputs: Auth_Reset_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una nueva contrasena.`)
};

/**
* | output |
* | --- |
* | "Set a new password for your account" |
*
* @param {Auth_Reset_Password_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_reset_password_description = /** @type {((inputs?: Auth_Reset_Password_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Password_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_password_description(inputs)
	return es_auth_reset_password_description(inputs)
});